import { useI18n } from 'vue-i18n';

export default function useLanguageManager() {
  const i18n = useI18n();

  function detectedLocale() {
    const lang = navigator.language;

    if (lang.includes('ko')) {
      setLocale('ko');
    } else if (lang.includes('id')) {
      setLocale('id');
    } else if (lang.includes('es')) {
      setLocale('es');
    } else {
      setLocale('en');
    }
  }
  function setLocale(locale: string) {
    i18n.locale.value = locale;
  }
  return { detectedLocale, setLocale };
}

export function useGetLocale() {
  function getLocale() {
    const lang = navigator.language;

    if (lang.includes('ko')) {
      return 'ko';
    } else if (lang.includes('id')) {
      return 'id';
    } else if (lang.includes('es')) {
      return 'es';
    } else {
      return 'en';
    }
  }
  return { getLocale };
}
